var ApiUrl = ''
if (!import.meta.env.DEV) {
    ApiUrl = 'https://rsvgw.rastargames.com'
}

export const api = {
    // 初始化
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/common-api-init
    init: ApiUrl + '/apiv1/comm/init',
    // 获取服务器时间
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/get-server-time
    time: ApiUrl + '/apiv1/comm/server-time',
    // 发送短信
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/rsvgw-sms-send
    // info: ApiUrl + 'https://api.rastargame.com',
    // 获取文章列表
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.08.14.45.08
    articles: ApiUrl + '/apiv1/comm/articles/list',
    // 获取栏目列表
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.08.14.44.41
    columns: ApiUrl + '/apiv1/comm/columns/list',
    // 获取栏目扩展字段
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.11.10.02.43
    additi: ApiUrl + '/apiv1/comm/additi/info',
    // 立即预约
    // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.12.15.02.30
    reserve: ApiUrl + '/rsvapiv1/comm/reserve/do',
    //预约里程碑
    milestone: ApiUrl + '/rsvapiv1/comm/reserve/milestone',
    //根据ip获取区号
    areaCode: ApiUrl + '/apiv1/comm/hybrid/country-info',
    // 获取活动信息
    activityInfo: ApiUrl + '/rsvapiv1/comm/hybrid/event-info',
    // 获取预约礼包
    giftLog: ApiUrl + '/rsvapiv1/comm/reserve/gift-log'
}